import { toApiConfig } from '~/business-logic/relationshipSummaryScope';
import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
export function useBulkSendResults(batchId, errorMessage, errorTestId) {
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const isVendor = useStore(selectors.user.isVendor);
    const { data, isLoading, error } = useQueryState({
        queryKey: [
            QueryKeys.BulkSendResults,
            batchId
        ],
        queryFn: async ()=>{
            const status = await api.draft.getBulkSendProposalsStatus(batchId);
            const sent = status.sentDraftIds.length > 0 && businessId != null ? await api.relationship.getSummaries(toApiConfig({
                kind: 'proposalsFromRun',
                draftIds: status.sentDraftIds
            }, {
                businessId,
                isVendor
            })) : [];
            return {
                status,
                sent
            };
        },
        refreshOnHookMount: true,
        toasts: {
            errorMessage,
            errorTestId
        }
    });
    return {
        results: data,
        isLoading,
        error
    };
}
